module.exports = __webpack_public_path__ + "media/images/map/payment1-419d78d4fdf71bf609b5c10b5035345c.svg";